import { render, staticRenderFns } from "./PremierLeague.vue?vue&type=template&id=407b60da&"
import script from "./PremierLeague.vue?vue&type=script&lang=js&"
export * from "./PremierLeague.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports